import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class servicesUrl {
  // public url = 'https://api2.gic-edu.net:444';
  public url = 'https://api2.isco-vision.com';
  // public url = 'https://api2.newtouch.sa';
}
